// extracted by mini-css-extract-plugin
export default {"title":"PlUy1jClX9r7sqPdIry5","todoTitle":"rEZ3DbcJHaGMiGq0R_zL","todoBox":"cjulxJIobr6oMq0IbP8Q","todoItem":"TLaLbOiHKV4sh3Q6j1xm","buttonRow":"nBg4K_vWeRJ1ObHzwjbU"};